import { EProductType } from '@common/enums/product-type.enum';
import { isFeeOnlyAddon } from './is-fee-addon/is-fee-addon.utils';
import { isShopAddon } from './is-shop-addon/is-shop-addon.util';

export const getAddonProductTypeFromId = (id: string): EProductType => {
    if (isShopAddon(id)) {
        return EProductType.shopAddon;
    }
    if (isFeeOnlyAddon(id)) {
        return EProductType.feeAddon;
    }
    return EProductType.addon;
};
